import {CampoFormularioModel} from './campo-formulario.model';
import {FaseModel} from './fase.model';
import {GatilhoCondicional} from './GatilhoCondicional';
import {Usuario} from '../cadastros/usuario.model';

export interface AssinaturaFormularioValor {
    nomeAssinante: string;
    cpfAssinante: string;
    imagemBase64?: string;
    caminhoImagem?: string;
    dataHoraAssinatura?: string;
}

export class PreenchFormModel {
   id?: number | undefined;
   data_hora?: Date | undefined;
   data_hora_update?: Date | undefined;
   pendente?: boolean | undefined;
   usuario_id?: number | undefined;
   usuario?: Usuario | undefined;
   usuarioNome?: string | undefined;
   usuarioAtualizacaoNome?: string | undefined;
   fase_id?: number | undefined;
   preenchimento_campo_id?: number | undefined;
   campo_formulario_id?: number | undefined;
   fechamento_formulario_id?: number | undefined;
   dados?: PreenchFormularioDadosModel[] | undefined;
   dadosComValores?: any | undefined;
   gatilho_condicional: GatilhoCondicional | undefined;
   gatilho_condicional_id: number | undefined;

   preenchimento_campo_ordem?: number | undefined;
   //conecta_preenchimentos?: String;

   gps?: Geo | undefined;

   // CAMPOS DE CONTROLE
   _campo?: CampoFormularioModel | undefined;
   _campo_form_visivel_id: number | undefined;
   _campo_form_visivel_nome: string | undefined;
   _fase?: FaseModel | undefined;

   _imgbase64: string[] | undefined;

   // TODO
   // CRIAR NO BANCO, SÓ COMO INTEIRO, NãO REFERENCIA CHAVE
   estrutura_id: number | undefined;
   conecta_preenchimentos: any;


    constructor(
        {
            id,
            campo_formulario_id,
            preench_campo_id,
            fechamento_formulario_id,
            usuario_id,
            dados,
            data_hora,
            pendente,
            usuario,
            fase_id,
            _fase,
            _campo,
            estrutura_id,
            _campo_form_visivel_id,
            _campo_form_visivel_nome,
            preenchimento_campo_ordem,
            conecta_preenchimentos,
            gatilho_condicional
        }:
        {
            id?: number;
            campo_formulario_id?: number;
            preench_campo_id?: number;
            fechamento_formulario_id?: number;
            usuario_id?: number;
            dados?: PreenchFormularioDadosModel[];
            data_hora?: Date;
            pendente?: boolean;
            usuario?: Usuario;
            fase_id?: number;
            _fase?: FaseModel;
            _campo?: CampoFormularioModel;
            estrutura_id?: number;
            _campo_form_visivel_id?: number;
            _campo_form_visivel_nome?: string;
            preenchimento_campo_ordem?: number;
            conecta_preenchimentos?: String;
            gatilho_condicional?: GatilhoCondicional;
        } = {}
    ) {
        this.id = id;
        this.campo_formulario_id = campo_formulario_id;
        this.preenchimento_campo_id = preench_campo_id;
        this.fechamento_formulario_id = fechamento_formulario_id;
        this.usuario_id = usuario_id;
        this.data_hora = data_hora;
        this.pendente = pendente;
        this.usuario = usuario;
        this.fase_id = fase_id;
        this._fase = _fase;
        // se passei a estrutura do campo, monta o json de dados com id da estrutura de campos
        this._campo = _campo;
        this._campo_form_visivel_id = _campo_form_visivel_id;
        this._campo_form_visivel_nome = _campo_form_visivel_nome;
        this.estrutura_id = estrutura_id;
        this.preenchimento_campo_ordem = preenchimento_campo_ordem;
        if (gatilho_condicional) {
            this.gatilho_condicional = gatilho_condicional;
        }
        if (_campo) {
            this.dados = [];
            for (const c of _campo.estrutura) {
                if (c.tipo === 'verdadeiroFalso') {
                    this.dados.push(new PreenchFormularioDadosModel(c.id));
                } else {
                    this.dados.push(new PreenchFormularioDadosModel(c.id));
                }
            }
        } else {
            this.dados = dados;
        }
    }
}

export class PreenchFormularioDadosModel {
   id: number | undefined;
   valor: string[] | string | boolean | number | {lat: string, lng: string, acc: string} | any | undefined;
   outro_valor?: string | null;

   constructor(id?: number, valor?: string[], outro_valor?: string) {
      this.id = id;
      this.valor = valor;
      this.outro_valor = outro_valor;
   }
}

export class PreenchientosConectados{
   conectaPreenchimentos: String;
   preenchimentos: PreenchFormModel[] = [];
   ordem: number;

   constructor(uuid: String, ordem: number){
      this.conectaPreenchimentos = uuid;
      this.ordem = ordem;
   }
}

export class Geo {
   lat: string;
   lng: string;
   acc: string;
}
